import React, {useState} from 'react';
import {Card, CardContent, Typography, Button, CardMedia} from '@mui/material';
import {useAppDispatch, useAppSelector} from '../../../hooks/hooks';
import {fetchAllGeneratedTours, resetTourDistances} from '../../../store/Vanlifer/tourSlice';
import {setSearchFormData} from "../../../store/Vanlifer/vanliferComponentsSlice";
import CuratorTippCard from "../../../pages/VanliferPages/TravelPlanning/CuratorTippCard";
import moment, { Moment } from 'moment/moment';
import DatePickerVanlife from '../../presentationalComponents/DatePickerVanlife';
import Box from "@mui/material/Box";

interface SearchCardProps {
    title: string;
    description?: string;
    regionId: number;
    compoundTypes?: string[];
    weekendOffset?: number; // -1 = freie Daten (Picker), 0 = nächstes Wochenende, 1 = übernächstes Wochenende usw..
    curationId?: number;
    imageUrl?: string;
    showCurator: boolean;
    curatorImageUrl?: string;
    buttonId?: string;
}

const SearchToursCard: React.FC<SearchCardProps> = ({
                                                        title,
                                                        description,
                                                        regionId,
                                                        compoundTypes = [],
                                                        weekendOffset = 0,
                                                        curationId = 0,
                                                        imageUrl,
                                                        showCurator = false,
                                                        curatorImageUrl,
                                                        buttonId,
                                                    }) => {

    const dispatch = useAppDispatch();
    const [customStart, setCustomStart] = useState<Moment | null>(null);
    const [customEnd, setCustomEnd] = useState<Moment | null>(null);


    const handleSearch = () => {
        let fromDate: number;
        let toDate: number;

        if (weekendOffset === -1 && customStart && customEnd) {
            fromDate = customStart.clone().add(12, 'hours').utc().startOf('day').valueOf();
            toDate = customEnd.clone().add(12, 'hours').utc().startOf('day').valueOf();
        } else {
            const today = moment();
            const startOfWeekend = today.clone().add(weekendOffset, 'weeks').day(5);
            const endOfWeekend = today.clone().add(weekendOffset, 'weeks').day(7);
            fromDate = startOfWeekend.clone().add(12, 'hours').utc().startOf('day').valueOf();
            toDate = endOfWeekend.clone().add(12, 'hours').utc().startOf('day').valueOf();
        }

        dispatch(setSearchFormData({
            startDate: weekendOffset === -1 ? customStart : moment(fromDate),
            endDate: weekendOffset === -1 ? customEnd : moment(toDate),
            regionId: regionId,
            curationId: curationId,
        }));

        dispatch(resetTourDistances());

        dispatch(fetchAllGeneratedTours({
            fromDate,
            toDate,
            regionId,
            compoundTypes,
            curationId
        }));
    };

    const card = (
        <Card sx={{ my: 2, height: '100%', minHeight: 400, display: 'flex', flexDirection: 'column' }}>
            {imageUrl && (
                <CardMedia
                    component="img"
                    height="160"
                    image={imageUrl.toString()}
                    alt={title}
                />
            )}
            <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                <Typography variant="h6">{title}</Typography>
                {description && (
                    <Typography variant="body2" color="textSecondary" gutterBottom>
                        {description}
                    </Typography>
                )}

                {weekendOffset === -1 && (
                    <Box mb={2} mt={1} display="flex" flexDirection="column" gap={1}>
                        <Box width="90%">
                            <DatePickerVanlife
                                value={customStart}
                                handleChange={(val) => setCustomStart(val)}
                                label="Startdatum"
                                name="customStart"
                                minDate={moment()}
                            />
                        </Box>
                        <Box width="90%">
                            <DatePickerVanlife
                                value={customEnd}
                                handleChange={(val) => setCustomEnd(val)}
                                label="Enddatum"
                                name="customEnd"
                                minDate={customStart || moment()}
                            />
                        </Box>
                    </Box>
                )}

                <Box mt="auto" display="flex" justifyContent="center">
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSearch}
                        id={buttonId}
                        disabled={weekendOffset === -1 && (!customStart || !customEnd)}
                    >
                        Suche starten
                    </Button>
                </Box>

            </CardContent>
        </Card>
    );


    return showCurator ? <CuratorTippCard curatorImageUrl={curatorImageUrl}>{card}</CuratorTippCard> : card;
};

export default SearchToursCard;
